<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import ComboSelect from '../ComboSelect/ComboSelect.svelte';
    import ElementTypeMigrationConfirmation from './ElementTypeMigrationConfirmation.svelte';
    import { sgettext } from '../../i18n.js';
    import {
        elementTypes,
        branchId,
        activityVersion,
        elementsUsedInActivity
    } from '../Workspaces/workspacesStore.js';
    import yup from 'yup';
    import { get, submit } from '../../utils.js';

    export let element = {type: 'NONE'};
    let currentPage = 1;
    let loading = true;
    let perPage = 10;
    let elementID = null;
    let oldElementType = null;
    let newElementType = null;
    let dataUrl = `${PATH_PREFIX}/sw/api/elements_database/elements/get_elements_used_in_activity/`;

    $: if (elementID !== element.elementId || !elementID) {
        elementID = element.elementId;
        oldElementType = element.type;
        newElementType = element.type;
    }

    $: isApmGoverned = $activityVersion?.activity_governance_type === 'APM Governed';

    const schema = yup.object().shape({
        element_type: yup.string()
                .required(sgettext('$$REQUIRED_FIELD$$'))
                .typeError(sgettext('$$REQUIRED_FIELD$$'))
    });

    function handleTypeChanged() {
        if (oldElementType !== newElementType) {
            elementsUsedInActivityResults();
            jQuery(`#elementTypeMigrationModalID`).modal('show');
        }
    }

    async function elementsUsedInActivityResults() {
      var url= `${dataUrl}?element_id=${elementID}&activity_version=${$activityVersion['id']}&limit=${perPage}&offset=${(currentPage - 1)*perPage}&page=${currentPage}`;
      const resp = await get(url);
      const re = await resp.json();
      try {
          elementsUsedInActivity.set(re);
          loading = false;
      } catch (err) {
          console.error(err);
          elementsUsedInActivity.set([]);
      } finally {
          loading = false;
      }
  }
</script>

<ComboSelect
    id="element_type"
    options={isApmGoverned ? $elementTypes.filter(e => e.id != 'QUALITY') : $elementTypes}
    bind:value={newElementType}
    on:changed={handleTypeChanged}
    searchable={false}
    {schema}
/>

<ElementTypeMigrationConfirmation {element} {newElementType} />



